import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'homePageViewed',
  'homeCtaClick',
  'recordsPageViewed',
  'recordingEntryViewed',
  'translationsPageViewed',
] as const;

export const homeEvents = getMappedEvents([...EVENTS], { shouldSendSubscriptionData: true });
